/**
 * Decodifica un string base64 y lo abre como PDF en una nueva pestaña
 * @param base64String - String base64 del PDF
 */
export function openPdfFromBase64(base64String: string): void {
  if (!base64String || base64String.length === 0) {
    console.warn("El string base64 está vacío");
    return;
  }

  try {
    // Decodificar base64 a binary string
    const binaryString = atob(base64String);

    // Convertir binary string a Uint8Array
    const bytes = new Uint8Array(binaryString.length);
    for (let i = 0; i < binaryString.length; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }

    // Crear Blob con tipo PDF
    const blob = new Blob([bytes], { type: 'application/pdf' });

    // Crear URL y disparar diálogo de impresión en iframe oculto
    const url = URL.createObjectURL(blob);
    const iframe = document.createElement('iframe');
    iframe.style.position = 'fixed';
    iframe.style.right = '0';
    iframe.style.bottom = '0';
    iframe.style.width = '0';
    iframe.style.height = '0';
    iframe.style.border = '0';
    iframe.style.scale = '100%';
    iframe.src = url;
    iframe.onload = () => {
      const win = iframe.contentWindow;
      win?.focus();
      win?.print();
      const cleanup = () => {
        URL.revokeObjectURL(url);
        iframe.remove();
        win?.removeEventListener('afterprint', cleanup);
      };
      win?.addEventListener('afterprint', cleanup);
    };
    document.body.appendChild(iframe);
  } catch (error) {
    console.error("Error al abrir PDF:", error);
    throw new Error("Error al procesar el archivo PDF");
  }
}

/**
 * Decodifica un string base64 y lo descarga como archivo
 * @param base64String - String base64 del PDF
 * @param filename - Nombre del archivo a descargar
 */
export function downloadPdfFromBase64(base64String: string, filename: string = "documento.pdf"): void {
  if (!base64String || base64String.length === 0) {
    console.warn("El string base64 está vacío");
    return;
  }

  try {
    // Decodificar base64 a binary string
    const binaryString = atob(base64String);

    // Convertir binary string a Uint8Array
    const bytes = new Uint8Array(binaryString.length);
    for (let i = 0; i < binaryString.length; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }

    // Crear Blob con tipo PDF
    const blob = new Blob([bytes], { type: 'application/pdf' });

    // Crear link de descarga y hacer click
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // Liberar la URL
    setTimeout(() => URL.revokeObjectURL(url), 100);
  } catch (error) {
    console.error("Error al descargar PDF:", error);
    throw new Error("Error al procesar el archivo PDF");
  }
}
